import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "kl-grid-pagination",
  templateUrl: "./grid-pagination.component.html",
  styleUrls: ["./grid-pagination.component.scss"],
})
export class GridPaginationComponent implements OnInit {
  constructor() {}
  @Input()
  pageOffset: number;
  @Input()
  totalCount: number;
  @Input()
  pageSize: number;
  @Output()
  onPageChange = new EventEmitter<number>();

  pageNumber = 1;

  static numberFloor(value: number) {
    return Math.floor(value);
  }

  ngOnInit() {
    this.pageNumber = this.numberCeil(this.totalCount / this.pageSize);
  }

  moveToFirstPage() {
    this.pageOffset = 0;
    this.onPageChange.emit(this.pageOffset);
  }

  moveToPreviousPage() {
    this.pageOffset -= this.pageSize;
    this.onPageChange.emit(this.pageOffset);
  }

  moveToNextPage() {
    this.pageOffset += this.pageSize;
    this.onPageChange.emit(this.pageOffset);
  }

  moveToLastPage() {
    this.pageOffset =
      GridPaginationComponent.numberFloor(this.totalCount / this.pageSize) *
      this.pageSize;
    this.onPageChange.emit(this.pageOffset);
  }

  numberCeil(value: number) {
    if (value >= 1) {
      return Math.ceil(value);
    } else {
      return 1;
    }
  }
}
